// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1jSKl","content":"LoadingAlert_content__1rdLZ"};